var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4950",
    "data-name": "Group 4950",
    transform: "translate(-35 -681)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17352",
    "data-name": "Rectangle 17352",
    width: 48,
    height: 48,
    transform: "translate(35 681)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "auto_stories_black_48dp",
    transform: "translate(39 684.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 40,
    height: 40,
    transform: "translate(0 0.096)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 0.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M3,7.291V25.309a18.525,18.525,0,0,1,12.727,0v-18A16.225,16.225,0,0,0,3,7.291Z",
    transform: "translate(0.636 4)",
    fill: "#2d73c7",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M23.091.5,14,9.591V26.864l9.091-8.182Z",
    transform: "translate(9.636 -0.5)",
    fill: "#2d73c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M40.036,6.182a19.22,19.22,0,0,0-2.673-1.109V26.945A18.706,18.706,0,0,0,31,25.818a19.268,19.268,0,0,0-10,2.873v-22A19.868,19.868,0,0,0,1.964,6.182,1.769,1.769,0,0,0,1,7.782V29.745a1.8,1.8,0,0,0,1.818,1.8,1.936,1.936,0,0,0,.873-.218A15.807,15.807,0,0,1,11,29.455a16.444,16.444,0,0,1,10,3.636,16.444,16.444,0,0,1,10-3.636,15.6,15.6,0,0,1,7.309,1.891,1.937,1.937,0,0,0,.873.218A1.807,1.807,0,0,0,41,29.764V7.782A1.769,1.769,0,0,0,40.036,6.182ZM17.364,26.945a18.525,18.525,0,0,0-12.727,0V8.927a16.225,16.225,0,0,1,12.727.018Z",
    transform: "translate(-1 2.364)",
    fill: "#2d73c7"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.4d7dd0a80fd9f4a5a917f33ee4d44101.svg";
export { ForwardRef as ReactComponent };